/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from 'react';
import { Stack } from '@mantine/core';
import { useForm } from '@mantine/form';
import FiltroAutos from '../FiltroAutos';
import ExportButton from '../ExportButton';
import Tabela from '../Tabela';
import api from '../../../utils/api';

const INITIAL_FILTER = {
  pagina: 0,
  tamanhoPagina: 10,
  direcaoOrdenacao: 'DESC',
  campoOrdenacao: null,
  pesquisaRapida: null,
  municipio: null,
  dataInicio: null,
  dataFim: null,
  numeroAutoInfracao: null
};

const TabAutos = () => {
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10
  });
  const [filtro, setFiltro] = useState(INITIAL_FILTER);
  const [dados, setDados] = useState([]);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const form = useForm({
    initialValues: {
      pesquisaRapida: '',
      numeroAutoInfracao: '',
      municipio: '',
      dataInicio: null,
      dataFim: null
    }
  });

  const downloadCSV = async () => {
    try {
      const filtroCSV = {
        ...filtro,
        tamanhoPagina: 1000000
      };
      const response = await api.post(`/api/fiscalizacao/transparencia/csv/auto-infracao`, filtroCSV, {
        responseType: 'arraybuffer'
      });
      
      const blob = new Blob([response.data], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'autos_infracao_transparencia.csv');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Erro ao baixar CSV:', error);
    }
  };

  const findAutoInfracoes = async (param) => {
    try {
      setIsLoading(true);
      const response = await api.post('/api/fiscalizacao/transparencia/auto-infracao/filtro', param);
      setDados(response.data.data.pageItems || []);
      setTotal(response.data.data.totalResults || 0);
    } catch (error) {
      console.error('Erro ao buscar autos de infração:', error);
      setDados([]);
      setTotal(0);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFilter = () => {
    const novoFiltro = {
      ...filtro,
      pagina: 0,
      pesquisaRapida: form.values.pesquisaRapida || null,
      numeroAutoInfracao: form.values.numeroAutoInfracao || null,
      municipio: form.values.municipio || null,
      dataInicio: form.values.dataInicio || null,
      dataFim: form.values.dataFim || null
    };
    setFiltro(novoFiltro);
    findAutoInfracoes(novoFiltro);
  };

  const clearFilter = () => {
    form.reset();
    setFiltro(INITIAL_FILTER);
    setPagination({ pageIndex: 0, pageSize: 10 });
    findAutoInfracoes(INITIAL_FILTER);
  };

  const columnsTable = useMemo(
    () => [
      {
        accessorKey: 'codigo',
        header: 'Código',
        mantineTableBodyCellProps: {
          align: 'left'
        },
        mantineTableHeadCellProps: {
          align: 'left'
        }
      },
      {
        accessorKey: 'dataOcorrencia',
        header: 'Data da Ocorrência',
        mantineTableBodyCellProps: {
          align: 'left'
        },
        mantineTableHeadCellProps: {
          align: 'left'
        }
      },
      {
        accessorKey: 'bioma',
        header: 'Bioma',
        mantineTableBodyCellProps: {
          align: 'left'
        },
        mantineTableHeadCellProps: {
          align: 'left'
        },
        Cell: ({ cell }) => {
          return "Amazônia";
        }
      },
      {
        accessorKey: 'municipio.nome',
        header: 'Município',
        mantineTableBodyCellProps: {
          align: 'left'
        },
        mantineTableHeadCellProps: {
          align: 'left'
        }
      },
      {
        accessorKey: 'municipio.estado.nome',
        header: 'Estado',
        mantineTableBodyCellProps: {
          align: 'left'
        },
        mantineTableHeadCellProps: {
          align: 'left'
        }
      },
      {
        accessorKey: 'pessoaAutuada.nome',
        header: 'Nome Autuado',
        mantineTableBodyCellProps: {
          align: 'left'
        },
        mantineTableHeadCellProps: {
          align: 'left'
        }
      },
      {
        accessorKey: 'pessoaAutuada.cpfCnpjFormatado',
        header: 'CPF/CNPJ',
        mantineTableBodyCellProps: {
          align: 'left'
        },
        mantineTableHeadCellProps: {
          align: 'left'
        }
      },
      {
        accessorKey: 'tipoInfracao.nome',
        header: 'Tipo Infração',
        mantineTableBodyCellProps: {
          align: 'left'
        },
        mantineTableHeadCellProps: {
          align: 'left'
        }
      },
      {
        accessorKey: 'condicao.nome',
        header: 'Status',
        mantineTableBodyCellProps: {
          align: 'left'
        },
        mantineTableHeadCellProps: {
          align: 'left'
        }
      },
      {
        accessorKey: 'descricaoInfracao',
        header: 'Sanções Aplicadas',
        mantineTableBodyCellProps: {
          align: 'left'
        },
        mantineTableHeadCellProps: {
          align: 'left'
        }
      },
      {
        accessorKey: 'dispositivoInfrigido.valorString',
        header: 'Dispositivo Infringido',
        mantineTableBodyCellProps: {
          align: 'left'
        },
        mantineTableHeadCellProps: {
          align: 'left'
        }
      },
      {
        accessorKey: 'complementoEnquadramento.valorString',
        header: 'Complemento Enquadramento',
        mantineTableBodyCellProps: {
          align: 'left'
        },
        mantineTableHeadCellProps: {
          align: 'left'
        }
      },
      {
        accessorKey: 'penalidade.descricao',
        header: 'Penalidade',
        mantineTableBodyCellProps: {
          align: 'left'
        },
        mantineTableHeadCellProps: {
          align: 'left'
        }
      },
      {
        accessorKey: 'penalidade.valor',
        header: 'Valor da Multa',
        mantineTableBodyCellProps: {
          align: 'left'
        },
        mantineTableHeadCellProps: {
          align: 'left'
        },
        Cell: ({ cell }) => {
          const valor = cell.getValue();
          return valor ? `R$ ${Number(valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` : 'N/A';
        }
      },
      {
        accessorKey: 'coordenadaLocalizacao.latitudeDecimal',
        header: 'Latitude',
        mantineTableBodyCellProps: {
          align: 'left'
        },
        mantineTableHeadCellProps: {
          align: 'left'
        }
      },
      {
        accessorKey: 'coordenadaLocalizacao.longitudeDecimal',
        header: 'Longitude',
        mantineTableBodyCellProps: {
          align: 'left'
        },
        mantineTableHeadCellProps: {
          align: 'left'
        }
      }
    ],
    []
  );

  useEffect(() => {
    findAutoInfracoes(filtro);
  }, []);

  useEffect(() => {
    if (
      pagination.pageIndex !== filtro.pagina ||
      pagination.pageSize !== filtro.tamanhoPagina
    ) {
      const novoFiltro = {
        ...filtro,
        pagina: pagination.pageIndex,
        tamanhoPagina: pagination.pageSize
      };
      setFiltro(novoFiltro);
      findAutoInfracoes(novoFiltro);
    }
  }, [pagination]);

  return (
    <Stack gap={'0'}>
      <FiltroAutos
        valorBusca={form.values.pesquisaRapida}
        setValorBusca={(value) => form.setFieldValue('pesquisaRapida', value)}
        municipio={form.values.municipio}
        setMunicipio={(value) => form.setFieldValue('municipio', value)}
        numeroAuto={form.values.numeroAutoInfracao}
        setNumeroAuto={(value) => form.setFieldValue('numeroAutoInfracao', value)}
        dataInicio={form.values.dataInicio}
        setDataInicio={(value) => form.setFieldValue('dataInicio', value)}
        dataFim={form.values.dataFim}
        setDataFim={(value) => form.setFieldValue('dataFim', value)}
        limparFiltros={clearFilter}
        aplicarFiltros={handleFilter}
      />
      <ExportButton onExport={downloadCSV} />
      <Tabela
        columns={columnsTable}
        data={dados}
        rowCount={total}
        title={'Listagem de Autos de Infração emitidos (Fiscalização Online)'}
        setPagination={setPagination}
        state={{
          pagination: {
            pageIndex: filtro.pagina,
            pageSize: filtro.tamanhoPagina
          }
        }}
        isLoading={isLoading}
      />
    </Stack>
  );
};

export default TabAutos;
